<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('categories')"
      :columns="columns"
      :column_search="true"
      resource_url="/note/category/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modal para crear/editar categorías -->
    <category-modal ref="category_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import CategoryModal from "./categories_datatable/category_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  error_message,
  del,
} from "@/utils";

export default {
  name: "Categories",
  components: { GenericTable, CategoryModal },
  data() {
    return {
      columns: [
        {
          title: this.$t("name"),
          name: "name",
          searchable: true,
          width: "40%",
          data: (row) => row.name || "",
        },
        {
          title: this.$t("description"),
          name: "description",
          searchable: true,
          width: "30%",
          data: (row) => row.description || "",
        },
        {
          title: this.$t("color"),
          width: "10%",
          data: (row) => {
            return `<span class="tag" style="background-color: ${
              row.color || "#3273dc"
            };">${row.color || "#3273dc"}</span>`;
          },
        },
        {
          title: this.$t("actions"),
          width: "20%",
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.category_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete category?"),
                    v,
                    () => {
                      del("/note/category", { uuid: uuid })
                        .then(() => {
                          v.refresh_datatable();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.category_modal.show_modal();
    },
    edit(row) {
      this.$refs.category_modal.show_modal(row.uuid);
    },
    delete(row) {
      confirm_deletion_dialog(this.$t("are_you_sure_delete"), this, () => {
        del("/note/category", { uuid: row.uuid })
          .then(() => {
            this.refresh_datatable();
          })
          .catch((error) => {
            console.error(error);
          });
      });
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
};
</script>
